import React, { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import CustomButton from '../../custom/custom-button/CustomButton';
import styles from "../common.module.scss";
import { User } from '../../../services';
import CircularProgress from '../../custom/circular-progress/CircularProgress';
import { t } from "i18next"

const EnterCodeComponent = ({ data, updateStep, setData }) => {
    const [code, setCode] = useState(['', '', '', '']);
    const inputs = useRef([]);
    const [isCodeValid, setIsCodeValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (value, index) => {
        if (/^\d$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (index < inputs.current.length - 1) {
                inputs.current[index + 1].focus();
            }

            if (newCode.every(digit => digit !== '')) {
                setIsCodeValid(true);
            } else {
                setIsCodeValid(false);
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (code[index]) {
                const newCode = [...code];
                newCode[index] = '';
                setCode(newCode);
                setIsCodeValid(false);
            } else if (index > 0) {
                inputs.current[index - 1].focus();
            }
        }
    };

    const nextStep = function () {
        setIsLoading(true);
        User.checkСodePassword(code.join(''))
            .then(response => {
                if (response.data.isActualCode === true) {
                    updateStep(3);
                    setData({ ...data, code: code.join('') });
                    setIsLoading(false);
                }
            })
            .catch(error => {
                toast.error("Введен неправильный код подтверждения")
                setIsLoading(false);
            });
    };

    return (
        <>
            <div className={styles.card_form}>
                <div className={styles.codeInputs}>
                    {code.map((digit, index) => (
                        <input
                            key={index}
                            ref={el => inputs.current[index] = el}
                            value={digit}
                            inputType="number"
                            maxLength={1}
                            onChange={e => handleChange(e.target.value, index)}
                            onKeyDown={e => handleKeyDown(e, index)}
                            className={styles.codeInput}
                            placeholder="0"
                        />
                    ))}

                    <div style={{ display: code.every(digit => digit === '') ? 'none' : 'block' }}>
                        <CircularProgress size={24} strokeWidth={2} stages={4} currentStage={code.filter(digit => digit).length} color="#2857FC" />
                    </div>
                </div>
            </div>

            <div className={styles.btns}>
                <CustomButton isFall isDisabled={!isCodeValid} text={t('restorePasswordPage.recover')} onClick={nextStep} isLoading={isLoading} />
                <CustomButton isFall text={t('restorePasswordPage.resendCode')} isUnderline={true} />
            </div>

        </>
    );
}

export default EnterCodeComponent;
